import { useEffect, useState } from 'react';
import { acquireSenderImage } from '../models/senderImageModel';

export function useMailSenderImage(image) {
  const downloadUrl = image?.availability === 'pending' || image?.availability === 'available' ? image.download_url : null;
  const [loaded, setLoaded] = useState(null);
  const [failedUrl, setFailedUrl] = useState(null);
  useEffect(() => {
    const request = acquireSenderImage(downloadUrl);
    if (!request) return undefined;
    let active = true;
    let url;
    request.promise.then(blob => {
      if (!active || !blob) return;
      url = URL.createObjectURL(blob);
      setLoaded({ downloadUrl, url });
    });
    return () => {
      active = false;
      request.release();
      if (url) URL.revokeObjectURL(url);
    };
  }, [downloadUrl]);
  return { url: loaded && loaded.downloadUrl === downloadUrl && failedUrl !== downloadUrl ? loaded.url : undefined, onError: () => setFailedUrl(downloadUrl) };
}
